import './styles/eha-bootstrap.scss'
import './styles/index.scss'
import React, { FC } from 'react';
import { AppRoutes } from './Routes';

const App: FC = () => <AppRoutes />;

export default App;
